<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="proformaExpenses" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="proformaExpenseId" selectionMode="single"
  [(selection)]="proformaExpense" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!proformaId) {
        <h1 style="float: left;margin: 6px;">Proforma Fees and Credits</h1>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!isPublicAndPublish) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">Fees & Credits +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expenseAmnt', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expensePct', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expenseFreq', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-proformaExpense>
    @if (proformaId && (proformaId == proformaExpense.proformaId)) {
      <tr  [pSelectableRow]="proformaExpense">
        <td>{{proformaExpense.name}}</td>
        <td>{{proformaExpense.description}}</td>
        <td>{{proformaExpense.quantity}}</td>
        <td>{{proformaExpense.expenseAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        <td>{{proformaExpense.expensePct | percent}}</td>
        <td>{{getStatusName(proformaExpense)}}</td>
        @if (!isPublicAndPublish) {
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proformaExpense)"></i>
            </a>
          </span>
        </td>
      }
    </tr>
  }

  @if (!proformaId) {
    <tr [pSelectableRow]="proformaExpense">
      <td>{{proformaExpense.proformaExpenseId}} </td>
      <td>{{proformaExpense.name}}</td>
      <td>{{proformaExpense.description}}</td>
      <td>{{proformaExpense.quantity}}</td>
      <td>{{proformaExpense.expenseAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
      <td>{{getStatusName(proformaExpense)}}</td>
      @if (!isPublicAndPublish) {
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proformaExpense)"></i>
          </a>
        </span>
      </td>
    }
  </tr>
}
</ng-template>
</p-table>